/* globals siteUrl:false, baseUrl:false; */
(function () {

    "use strict";

    var appUI = {

        firstMenuWidth: 190,
        secondMenuWidth: 300,
        menuWrapper: document.getElementById('menu'),
        loaderAnimation: document.getElementById('loader'),
        secondMenuTriggerContainers: $('#menu #main #elementCats, #menu #main #componentCats, #menu #main #templatesUl, #menu #main #pages'),
        catDropdownTriggers: $('#main h3'),
        siteUrl: siteUrl,
        baseUrl: baseUrl,
        gridViewMode: false,

        setup: function(){

            // Fade the loader animation
            $(appUI.loaderAnimation).fadeOut(function(){
                $('#menu').animate({'left': -appUI.firstMenuWidth}, 1000);
            });

            // Tabs
            $(".nav-tabs a").on('click', function (e) {
                e.preventDefault();
                $(this).tab("show");
            });

            $("select.select").select2({
                minimumResultsForSearch: -1
            });

            $(':radio, :checkbox').radiocheck();

            // Tooltips
            $("[data-toggle=tooltip]").tooltip("hide");

            // Table: Toggle all checkboxes
            $('.table .toggle-all :checkbox').on('click', function () {
                var $this = $(this);
                var ch = $this.prop('checked');
                $this.closest('.table').find('tbody :checkbox').radiocheck(!ch ? 'uncheck' : 'check');
            });

            // Add style class name to a tooltips
            $(".tooltip").addClass(function() {
                if ($(this).prev().attr("data-tooltip-style")) {
                    return "tooltip-" + $(this).prev().attr("data-tooltip-style");
                }
            });

            $(".btn-group").on('click', "a", function() {
                $(this).siblings().removeClass("active").end().addClass("active");
            });

            // Focus state for append/prepend inputs
            $('.input-group').on('focus', '.form-control', function () {
                $(this).closest('.input-group, .form-group').addClass('focus');
            }).on('blur', '.form-control', function () {
                $(this).closest('.input-group, .form-group').removeClass('focus');
            });

            // Table: Toggle all checkboxes
            $('.table .toggle-all').on('click', function() {
                var ch = $(this).find(':checkbox').prop('checked');
                $(this).closest('.table').find('tbody :checkbox').checkbox(!ch ? 'check' : 'uncheck');
            });

            // Table: Add class row selected
            $('.table tbody :checkbox').on('check uncheck toggle', function (e) {
                var $this = $(this)
                , check = $this.prop('checked')
                , toggle = e.type === 'toggle'
                , checkboxes = $('.table tbody :checkbox')
                , checkAll = checkboxes.length === checkboxes.filter(':checked').length;

                $this.closest('tr')[check ? 'addClass' : 'removeClass']('selected-row');
                if (toggle) $this.closest('.table').find('.toggle-all :checkbox').checkbox(checkAll ? 'check' : 'uncheck');
            });

            // Switch
            //$("[data-toggle='switch']").wrap('<div class="switch" />').parent().bootstrapSwitch();
            $('[data-toggle="switch"]').bootstrapSwitch();

            appUI.secondMenuTriggerContainers.on('click', 'a:not(.btn, .fileEdit, .fileDel, .fileSave)', appUI.secondMenuAnimation);

            //modal links which open a tab inside that modal
            $('*[data-toggle="modal"][data-open-tab]').on('click', function () {
                $(this.getAttribute('href') + ' .nav-tabs li:nth-child(' + Number(this.getAttribute('data-open-tab')) + ') a').tab('show');
            });

            appUI.catDropdownTriggers.on('click', appUI.toggleCatDropdown);

            //sitebar hover animation action
            $(this.menuWrapper).on('mouseenter', function(){

                $(this).stop().animate({'left': '0px'}, 500);

            }).on('mouseleave', function(){

                $(this).stop().animate({'left': '-190px'}, 500);

                $('#menu #main a').removeClass('active');
                $('.menu .second').stop().animate({
                    width: 0
                }, 500, function(){
                    $('#menu #second').hide();
                });

            });

        },

        secondMenuAnimation: function(){

            $('#menu #main a').removeClass('active');
            $(this).addClass('active');

            //show only the right elements
            $('#menu #second ul li').hide();
            //make sure the images are loaded
            $('#menu #second ul li.'+$(this).attr('id')).each(function () {

                if ( this.querySelector('img') && !this.querySelector('img').hasAttribute('src') ) {
                    this.querySelector('img').setAttribute('src', this.querySelector('img').getAttribute('data-original-src'));
                }

            }); 
            $('#menu #second ul li.'+$(this).attr('id')).show();

            if( $(this).attr('id') === 'all' ) {
                $('#menu #second ul li').each(function () {

                    if ( this.querySelector('img') && !this.querySelector('img').hasAttribute('src') ) {
                        this.querySelector('img').setAttribute('src', this.querySelector('img').getAttribute('data-original-src'));
                    }

                }); 
                $('#menu #second ul#elements li').show();
            }

            $('.menu .second').css('display', 'block').stop().animate({
                width: appUI.secondMenuWidth
            }, 500);

        },

        toggleCatDropdown: function (e) {

            var theUL = this.nextElementSibling,
                x,
                currentVisible = false,
                style = window.getComputedStyle(theUL);

            if ( style.display === 'block' ) currentVisible = true;

            for ( x = 0; x < appUI.secondMenuTriggerContainers.length; x++ ) {

                $(appUI.secondMenuTriggerContainers[x]).slideUp();

            }

            for ( x = 0; x < appUI.catDropdownTriggers.length; x++ ) {

                appUI.catDropdownTriggers[x].classList.remove('active');

            }

            if ( !currentVisible ) {
                e.currentTarget.classList.add('active');
                $(theUL).slideDown();
            }

        }

    };

    //initiate the UI
    appUI.setup();


    //**** EXPORTS
    module.exports.appUI = appUI;

}());


//////////////////
// WEBPACK FOOTER
// ./assets/js/modules/ui.js
// module id = 73
// module chunks = 1 2 5 8 9 10